/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { TriggerManualRunFromScheduledAodRulesMutationResponse, TriggerManualRunFromScheduledAodRulesPathParams, TriggerManualRunFromScheduledAodRules400, TriggerManualRunFromScheduledAodRules404 } from "../models/TriggerManualRunFromScheduledAodRules";

export function getTriggerManualRunFromScheduledAodRulesUrl(scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"]) {
  const res = { method: 'POST', url: `/aod-rules/scheduled-runs/${scheduledJobId}/trigger` as const }
  return res
}

/**
 * @description Triggers a manual AOD run based on an existing scheduled run configuration
 * @summary Trigger a manual AOD run based on a scheduled run
 * {@link /aod-rules/scheduled-runs/:scheduledJobId/trigger}
 */
export async function triggerManualRunFromScheduledAodRules(scheduledJobId: TriggerManualRunFromScheduledAodRulesPathParams["scheduledJobId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<TriggerManualRunFromScheduledAodRulesMutationResponse, ResponseErrorConfig<TriggerManualRunFromScheduledAodRules400 | TriggerManualRunFromScheduledAodRules404>, unknown>({ method : "POST", url : getTriggerManualRunFromScheduledAodRulesUrl(scheduledJobId).url.toString(), ... requestConfig })
  return res.data
}